import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';

import { ButtonsAngularModule } from 'rev-shared/ui/buttons/ButtonsAngular.Module';
import { DateAngularModule } from 'rev-shared/date/DateAngular.Module';
import { FormGroupAngularModule } from 'rev-shared/ui/formGroup/FormGroupAngular.Module';
import { PipesAngularModule } from 'rev-shared/pipes/Pipes.AngularModule';
import { TextInputAngularModule } from 'rev-shared/ui/text-input/TextInputAngular.Module';
import { ValidationAngularModule } from 'rev-shared/ui/validation/ValidationAngular.Module';
import { ValidationModule } from 'rev-shared/util/directives/form/validation/Validation.AngularModule';
import { VbNgSelectWrapModule } from 'rev-shared/ui/ng-select/VbNgSelectWrap.Module';
import { VbUiTooltipComponent } from 'rev-shared/ui/tooltip/VbUiTooltip.Component';
import { VbUiHtmlEditorComponent } from 'rev-shared/htmlEditor/VbUiHtmlEditor.Component';

import { EmbeddedContentEntryComponent } from './EmbeddedContentEntry.Component';
import { EmbeddedContentAddFormComponent } from './EmbeddedContentAddForm.Component';
import { BannerEntryComponent } from './BannerEntry.Component';
import { BannerAddFormComponent } from './BannerAddForm.Component';
import { WebcastBackgroundAngularDirective } from './WebcastBackground.AngularDirective';

const exports = [
	EmbeddedContentAddFormComponent,
	EmbeddedContentEntryComponent,
	BannerAddFormComponent,
	BannerEntryComponent,
	WebcastBackgroundAngularDirective
];

@NgModule({
	declarations: exports,
	exports,
	imports: [
		ButtonsAngularModule,
		CommonModule,
		DateAngularModule,
		FormGroupAngularModule,
		FormsModule,
		NgSelectModule,
		NgxTrimDirectiveModule,
		PipesAngularModule,
		TextInputAngularModule,
		TranslateModule,
		ValidationAngularModule,
		ValidationModule,
		VbNgSelectWrapModule,
		VbUiTooltipComponent,
		VbUiHtmlEditorComponent
	]
})
export class ScheduledEventsCommonModule {}
